import FilterDashboardActionTypes from './action-types';

const initialState = {
  filterCycle: false,
  filterOrder: 'name',
  selectedSpecies: ['shrimp'],
  filterStatus: '',
  filterStatusNursery: '',
  filterType: '',
  cycles: [],
  selectedCycles: [],
};

// eslint-disable-next-line default-param-last
const filterDashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case FilterDashboardActionTypes.FILTER_STATUS:
      return { ...state, filterStatus: action.payload };
    case FilterDashboardActionTypes.FILTER_STATUS_NURSERY:
      return { ...state, filterStatusNursery: action.payload };
    case FilterDashboardActionTypes.FILTER_TYPE:
      return { ...state, filterType: action.payload };
    case FilterDashboardActionTypes.FILTER_CYCLE:
      return { ...state, filterCycle: action.payload };
    case FilterDashboardActionTypes.SELECTED_SPECIES:
      return { ...state, selectedSpecies: action.payload };
    case FilterDashboardActionTypes.SELECTED_CYCLES:
      return { ...state, selectedCycles: action.payload };
    case FilterDashboardActionTypes.CYCLES:
      return { ...state, cycles: action.payload };
    case FilterDashboardActionTypes.FILTER_ORDER:
      return { ...state, filterOrder: action.payload };
    default:
      return state;
  }
};

export default filterDashboardReducer;
